/*
 * Fix: language / country dropdowns in the announcement bar close as soon as the pointer
 * moves from the toggle button into the dropdown, so no option can be selected.
 *
 * Cause: in this Concept version `aria-controls` sits on the <button>, and DropdownElement
 * binds its hover listeners to that button. The dropdown panel is a sibling of the button,
 * so moving into it fires `mouseleave` on the button → hide().
 *
 * This replaces the button hover handling so the dropdown only closes when the pointer
 * leaves the whole `.localization__item` (button + panel). theme.js is left untouched.
 * Load after theme.js.
 */
(() => {
  const patch = (root = document) => {
    root.querySelectorAll('dropdown-localization').forEach((dropdown) => {
      if (dropdown.hasAttribute('data-hover-fix') || !dropdown.detectHoverListener) return;
      dropdown.setAttribute('data-hover-fix', '');

      const wrapper = dropdown.parentElement;
      const onLeave = (event) => {
        if (theme.config.isTouch) return;
        if (!wrapper.contains(event.relatedTarget)) dropdown.hide();
      };

      dropdown.controls.forEach((button) => {
        button.removeEventListener('mouseenter', dropdown.detectHoverListener);
        button.removeEventListener('mouseleave', dropdown.detectHoverListener);
        button.addEventListener('mouseenter', () => {
          if (!theme.config.isTouch && !dropdown.open) dropdown.show();
        });
        button.addEventListener('mouseleave', onLeave);
      });
      wrapper.addEventListener('mouseleave', onLeave);
    });
  };

  patch();
  document.addEventListener('shopify:section:load', (event) => patch(event.target));
})();
